/**
 * @desc 获取国家树形结构
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<Array<defs.basics.BaseCountryTreeResponseRpcDto>>;
export function request(
  body: defs.basics.BaseCountryRequestParamsDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/country/tree`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
